import PairedExchangesGrid from "./PairedExchangesGrid";

/**
 * Renders the "Exchange Pairs" page
 * @returns {JSX.Element}
 * @constructor
 */
const ExchangePairsPage = () => {

    return (
        <div>
            <PairedExchangesGrid />
        </div>
    );
}

export default ExchangePairsPage;
